import { Avatar, List } from "antd";
import React from "react";
import { RiFile2Fill } from "react-icons/ri";

import { useTranslation } from "react-i18next";
const Files = () => {
  const { t } = useTranslation("dashboard");
  const data = [
    {
      icon: <RiFile2Fill />,
      content: "First file.pdf",
      time: "10:25 pm"
    },
    {
      icon: <RiFile2Fill />,
      content: "File2.json",
      time: "09:25 pm"
    }
  ];

  return (
    <div className="activity-section">
      <h3>{t("Files")}</h3>
      <List
        itemLayout="horizontal"
        dataSource={data}
        renderItem={item => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar icon={item.icon} />}
              title={item.content}
              description={item.time}
            />
          </List.Item>
        )}
      />
    </div>
  );
};

export default Files;
